export * from './app-trans.tsx'
